<template>
  <SysDialog
    v-model="dialog_ativo"
    :largura="1000"
    ocultar-acoes
    titulo="Mais Detalhes do Produto"
  >
    <template #ativador>
      <v-btn icon x-small @click="dialog_ativo = ! dialog_ativo">
        <v-icon :size="16">mdi-information-outline</v-icon>
      </v-btn>
    </template>

    <CaracteristicasProduto
      :produto="{
        id_grupo: props.id_grupo,
        id_filial: 9999,
        id_produto: props.idproduto
      }"
    />
  </SysDialog>
</template>

<script setup>
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import {ref} from "vue";
import CaracteristicasProduto from "@/components/produto/detalhes/TabelaCaracteristicasProduto.vue";

const props = defineProps({
  id_grupo: Number,
  idproduto: String
})

const dialog_ativo = ref(false);
</script>
